import React from 'react';
import { Link } from 'react-router-dom';

export const SolutionCtaBanner: React.FC<{
  title: string;
  ctaLabel: string;
  ctaTo: string;
  imageSrc: string;
  imageAlt?: string;
}> = ({ title, ctaLabel, ctaTo, imageSrc, imageAlt }) => {
  return (
    <section className="solution-cta-banner" aria-label="Request demo">
      <div className="solution-cta-banner__inner">
        <div className="solution-cta-banner__content">
          <h3 className="solution-cta-banner__title">{title}</h3>
          <div className="solution-cta-banner__actions">
            <Link className="solution-cta-banner__btn" to={ctaTo}>
              {ctaLabel}
            </Link>
          </div>
        </div>

        <div className="solution-cta-banner__art" aria-hidden>
          <img src={imageSrc} alt={imageAlt ?? ''} loading="lazy" />
        </div>
      </div>
    </section>
  );
};

